import { createSelector } from 'reselect';

export const getSideOrdersReducer = state => state.sideOrdersReducer;

export const getMultipleSideOrders = createSelector(
  [getSideOrdersReducer],
  sideOrders => sideOrders.filter(item => !item.customDates)
);
